export default {
    attached_photos: [],
    category: "",
    created_by: false,
    icon_url: "",
    toolbox_id: "",
    toolbox_topic: "",
    created_timestamp: "",
};
